export default {
  netType: {
    WIRED: '有线',
    WIRELESS: '无线'
  },
  terminalPlatform: {
    IDV: 'IDV模式',
    VDI: 'VDI模式',
    VOI: 'TCI模式'
  },
  terminalMode: {
    PERSONAL: '单用户模式',
    MULTI_USER: '多用户模式',
    PUBLIC: '无帐号模式'
  },
  deskPattern: {
    PERSONAL: '个性桌面',
    RECOVERABLE: '还原桌面'
  }
}
